

export const ImageData =[
    {
        image:'./images2/ci4.jpg'
    },
    {
        image:'./images2/ci5.jpg'
    },
    {
        image:'./images2/ci6.jpg'
    }
    // ,
    // {
    //     image:'https://cdn.theatlantic.com/thumbor/Iff9TkXlgMyEbs8wK6JeGUbHK0w=/0x57:1088x669/960x540/media/img/mt/2015/07/minions1/original.jpg'
    // }
    ]